'use strict';

var DropdownDirective = function () {

  var link = function link (scope, el) {
    var input = angular.element(el[0].children[0].children[0].children[0]);
    var modelIsEmpty;

    if (scope.multi) {
      input.on('keyup', function (e) {
        var keyCode = e.keyCode || e.which;

        if (keyCode === 8 && modelIsEmpty && scope.selected.length) {
          scope.selected.pop();
          scope.$digest();
        }

        modelIsEmpty = scope.model ? !(!!scope.model.length) : true;
      });
    } else {
      // prevent user from typing in input
      input.on('keydown', function (e) {
        e.preventDefault();

        return false;
      });
    }
  };

  var controller = function controller ($scope) {
    var model = $scope.model;
    var vm = this;
    if($scope.selected && $scope.selected.length && !$scope.multu) {
      $scope.model = $scope.selected[0][$scope.displayProperty];
    }
    else {
      $scope.selected = [];
    }

    vm.editSelect = false;

    // hide the dropdown if it's open and user exits out of Edit Settings
    $scope.$watch('edit', function (newValue) {
      if (!newValue && vm.editSelect) {
        vm.editSelect = false;
      }
    });

    vm.select = function select (option) {
      if (typeof option === undefined) {
        option = model;
      }

      if (option) {
        if ($scope.selected.indexOf(option) === -1) {
          if ($scope.multi) {
            $scope.selected.push(option);
          } else {
            $scope.selected = [option];
          }

          if ($scope.onchange) {
            $scope.onchange($scope.selected);
          }
        }

        if (!$scope.multi) {
          $scope.model = model = option[$scope.displayProperty];
        }
      }

      vm.editSelect = !vm.editSelect;
    };

    vm.remove = function remove (selection) {
      var index = $scope.selected.indexOf(selection);
      $scope.selected.splice(index, 1);
    };
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    scope: {
      displayProperty: '@?',
      edit: '=?',
      label: '=?',
      model: '=',
      multi: '=?',
      selected: '=',
      options: '=',
      onchange: '='
    },
    templateUrl: 'settings/directives/dropdown.tpl.html',
    controller: ['$scope', controller],
    controllerAs: 'vm',
    link: link
  };
};

module.exports = DropdownDirective;



// WEBPACK FOOTER //
// ./src/app/settings/directives/DropdownDirective.js